<app-add-member-dialog
  [multiSelect]="multi()"
  [membersInGrid]="membersInGrid()"
  [selectedUser]="memberGridRow()?.member"
  [extraFields]="expenditureTpl"
  [beforeSubmitted]="dialogClosed"
></app-add-member-dialog>

<!-- The template gets the child form via let-form -->
<ng-template #expenditureTpl let-form="form">
  @if (addExtraControls(form)) {
    <div [formGroup]="form">
      @if (showHourlyExpenditureRateFormField()) {
        <div
          class="k-d-grid"
          style="grid-template-columns: minmax(115px, max-content) auto; margin-bottom: 1.5rem"
        >
          <kendo-label class="!k-align-items-start" [text]="'Stundensatz'"></kendo-label>
          <div class="k-d-flex">
            <span class="prefix-currency">&euro;</span>
            {{ rateAndBudget()[0] }}
            <fa-icon
              class="edit turquoise icon-button k-display-flex k-align-items-stretch k-ml-3.5 fa-md"
              role="button"
              (click)="
                projectMemberGridService.openNewExpenditureRateDialog(
                  memberGridRow(),
                  makeApplyResult
                )
              "
              [icon]="faPenToSquare"
            ></fa-icon>
          </div>
        </div>
      }

      @if (showBudgetHoursPerMemberFormField()) {
        <kendo-formfield orientation="horizontal">
          <kendo-label text="Budget"></kendo-label>
          <div class="k-d-flex">
            <kendo-timepicker
              [formControlName]="formControlNames.BudgetHoursPerMember"
              [format]="'HH:mm'"
            ></kendo-timepicker>
          </div>
        </kendo-formfield>
      }

      <div
        class="k-d-grid k-align-items-center"
        style="
          grid-template-columns: minmax(117px, max-content) auto;
          margin-bottom: 1.5rem;
          height: 40px;
        "
      >
        <kendo-label text="Von Budget abziehen" [for]="deductFromBudget"></kendo-label>
        <div class="k-form-field-checkbox-wrap">
          <input
            #deductFromBudget
            type="checkbox"
            kendoCheckBox
            [formControlName]="formControlNames.DeductFromBudget"
          />
        </div>
      </div>
    </div>
  }
</ng-template>
